module.exports = __webpack_public_path__ + "static/media/home-icon-blue.344b8a32.svg";